import { observer } from 'mobx-react-lite'
import React from 'react'
import { Error, Label } from 'shared/ui'
import { makeTextFieldIcon } from 'shared/ui/TextField'
import { SendFrom } from 'widgets/SendFrom'
import { type SendFromBlockStore } from 'widgets/Flow/blocks/SendFrom'
import styles from './styles.module.scss'

type ISendFromBlockActionEditContentProps = {
  store: SendFromBlockStore
  labelText?: string
}
export const SendFromBlockActionEditContent = observer(
  ({ store, labelText = 'Send from' }: ISendFromBlockActionEditContentProps) => {
    const { sendFromStore, error, setError } = store
    return (
      <div className={styles.sendFrom}>
        <Label
          label={{
            text: labelText,
          }}
        />
        <SendFrom
          store={sendFromStore}
          triggerVariant={'textField'}
          width={358}
          textFiledTriggerProps={{
            textFieldPlaceholderProps: {
              variant: 'stroke',
              size: 'medium',
              className: styles.textField,
              errorState: !!error,
              rightActions: [
                makeTextFieldIcon({
                  icon: 'chevronDown',
                }),
              ],
            },
          }}
          onClearError={() => setError('')}
        />
        {!!error && <Error type={'text'} error={error} />}
      </div>
    )
  }
)
